import React from 'react';
import { IUserContext } from '../interfaces/IUserContext';
const userInfo = new IUserContext();

export default React.createContext(userInfo);